<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container grid-list-xl pt-0>
            <v-layout row wrap justify-end align-center>
                <!-- <v-toolbar-title>
                    <v-icon>receipt</v-icon>
                    DANH SÁCH
                </v-toolbar-title>
                <v-spacer></v-spacer> -->
                <v-flex xs12 md2>
                    <v-text-field
                        v-model="search"
                        prepend-icon="search"
                        label="Tìm kiếm"
                        hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="menu_date_start"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <v-text-field
                            slot="activator"
                            v-model="date_start"
                            label="Ngày bắt đầu"
                            :disabled="loading.submit"
                            prepend-icon="event"
                            readonly
                            hide-details
                        ></v-text-field>
                        <v-date-picker locale="vi-VI" v-model="date_start" @input="menu_date_start = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12 md2>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="menu_date_end"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        hide-details
                    >
                        <v-text-field
                            slot="activator"
                            v-model="date_end"
                            label="Ngày kết thúc"
                            :disabled="loading.submit"
                            prepend-icon="event"
                            readonly
                            hide-details
                        ></v-text-field>
                        <v-date-picker locale="vi-VI" v-model="date_end" @input="menu_date_end = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12 md2>
                    <v-select
                        label="Hình thức"
                        :disabled="loading.submit"
                        v-model="chosen_payment_type"
                        :items="list_payment_type"
                        prepend-icon="monetization_on"
                        required
                        hide-details
                    ></v-select>
                </v-flex>
                <v-flex v-if="role == 'admin'" xs12 md1>
                    <v-select
                        label="Loại"
                        :disabled="loading.submit"
                        v-model="chosen_deposit_type"
                        :items="list_deposit_type"
                        prepend-icon="receipt"
                        required
                        hide-details
                    ></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="dialog = !dialog" color="green" dark>
                            <!-- <v-icon small dark left>add_box</v-icon> -->
                            Tạo Phiếu mới
                        </v-btn>
                        <v-btn :loading="export_csv.loading" @click="exportCSV" color="primary" dark>XUẤT EXCEL</v-btn>
                        <export-csv-button
                            :trigger="export_csv.trigger"
                            :title="export_csv.title"
                            :rows="export_csv.rows"
                        ></export-csv-button>
                    </div>
                </v-flex>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            disable-initial-sort
                            :headers="headers"
                            :items="filtered_items"
                            :search="search"
                            item-key="id"
                            :rows-per-page-items="rowPerPage"
                        >
                            <!-- <template #headers="props">
                                <tr>
                                    <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template> -->
                            <template #items="props">
                                <tr>
                                    <td class="text-no-wrap">
                                        <v-menu offset-y v-if="props.item.is_valid">
                                            <v-btn icon slot="activator">
                                                <v-icon small color="#464D69">settings</v-icon>
                                            </v-btn>
                                            <v-list>
                                                <v-list-tile
                                                    @click="triggerDialog(props.item, 'edit')"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Chỉnh sửa
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    v-if="!props.item.is_check_in && props.item.deposit_type == 1"
                                                    @click="triggerDialog(props.item, 'transfer')"
                                                >
                                                    <v-list-tile-action>
				                                        <v-icon small class="zmdi zmdi-refresh-alt"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Chuyển cọc
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    v-if="props.item.is_valid && !props.item.is_check_in && props.item.deposit_type == 1"
                                                    @click="cancelDeposit(props.item)"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-calendar-close"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Hủy cọc
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                            <!-- <chuyen-coc-component v-if="props.item.is_valid && !props.item.is_check_in && props.item.deposit_type == 1" @changeRoomId="changeRoomId" :selected_receipt="props.item" :list_building="list_building"></chuyen-coc-component>
                                            <v-tooltip v-if="props.item.is_valid && !props.item.is_check_in && props.item.deposit_type == 1" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn class="ma-0" v-on="on" flat icon color="warning" @click="cancelDeposit(props.item)">
                                                        <v-icon class="zmdi zmdi-calendar-close"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Hủy cọc</span>
                                            </v-tooltip> -->
                                        </v-menu>
                                    </td>
                                    <td class="text-center text-no-wrap">
                                        <span class="v-badge primary">
                                            Cọc lần {{ props.item.deposit_type }}
                                        </span>
                                    </td>
                                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                                    <td class="text-no-wrap">{{ props.item.date_deposit | formatTimeServer}}</td>
                                    <td class="text-no-wrap">{{ props.item.date_schedule_in | formatTimeServer}}</td>
                                    <td class="text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">
                                        <span
                                            v-if="props.item.receipt_status !== 0"
                                            :class="props.item.is_collected ? 'v-badge primary' : 'v-badge warning'"
                                        >
                                            {{ props.item.receipt_status == 2 ? 'Chủ Trọ đã thu' : 'Chủ Trọ chưa thu' }}
                                        </span>
                                        <span v-else class="v-badge error">Đã hủy cọc</span>
                                    </td>
                                    <td class="text-no-wrap">{{ !props.item.is_check_in ? 'Chưa nhận phòng' : 'Đã nhận phòng'}}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.wallet_account_id | translateWalletName }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.agent_name }}</td>
                                    <td class="text-no-wrap">{{ props.item.name }}</td>
                                    <td class="text-no-wrap">{{ props.item.phone }}</td>
                                    <td class="text-no-wrap">{{ props.item.room_price | formatNumber}}</td>
                                    <td class="text-no-wrap">{{ props.item.deposit_amount | formatNumber}}</td>
                                    <td class="text-no-wrap">{{ props.item.note }}</td>
                                    <!-- <td v-if="role === 'ADMIN'" class="text-no-wrap">
                                    </td> -->
                                </tr>
                            </template>
                            <template #no-data>
                                Chưa có thông tin
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
		</v-container>
        <v-dialog :persistent="form.room_state_id ? true : false" v-model="dialog" max-width="80%">
            <app-card>
                <app-section-loader :status="form_loader"></app-section-loader>
                <v-btn right icon absolute small @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <h4>PHIẾU THU TIỀN CỌC</h4>
                <p v-if="!form.room_state_id" class="fs-14 grey--text mb-1">Tạo phiếu thu tiền cọc</p>
                <template v-else>
                    <p class="fs-14 mb-1 v-badge primary">Phiếu cọc lần: {{form.deposit_type}}</p>
                    <p v-if="form.deposit_type !== 1" class="fs-14 grey--text mb-1">Tổng số tiền đã cọc: {{total_amount_deposited | formatNumber}} VND</p>
                    <p v-if="form.deposit_type !== 1 && total_amount_must_deposit" class="fs-14 grey--text">Tổng số tiền phải cọc: {{(total_amount_must_deposit) | formatNumber}} VND</p>
                </template>
                <v-btn v-if="role === 'ADMIN'"  @click="$refs.inputUpload.click()" color="green" dark>
                    Nhập excel (admin)
                </v-btn>
                <input v-show="false" ref="inputUpload" type="file" @change="onFileSelected" >
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap :justify-center="!form.room_state_id" :justify-start="form.room_state_id">
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    :rules="requireText"
                                    required
                                    @change="getReceiptNewestNumber"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    :rules="requireText"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 v-if="alert.show">
                                <v-alert
                                    :value="alert.show"
                                    :type="alert.type"
                                    outline
                                >
                                    {{ alert.text }}
                                </v-alert>
                            </v-flex>
                            <template v-if="form.room_state_id">
                                <v-flex xs12 md3>
                                    <v-menu
                                        :close-on-content-click="false"
                                        v-model="menu_date_deposit"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="form.date_deposit"
                                            label="Ngày đặt cọc"
                                            :disabled="loading.submit"
                                            prepend-icon="event"
                                            readonly
                                            :rules="requireText"
                                        ></v-text-field>
                                        <v-date-picker locale="vi-VI" v-model="form.date_deposit" @input="menu_date_deposit = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex v-if="form.deposit_type === 1" xs12 md3>
                                    <v-menu
                                        :close-on-content-click="false"
                                        v-model="menu_date_schedule_in"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="form.date_schedule_in"
                                            label="Ngày hẹn vào ở"
                                            :disabled="loading.submit"
                                            prepend-icon="event"
                                            readonly
                                            :rules="requireText"
                                        ></v-text-field>
                                        <v-date-picker locale="vi-VI" v-model="form.date_schedule_in" @input="menu_date_schedule_in = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <!-- <v-flex xs12 md3>
                                    <v-text-field
                                        label="Mã quản lý"
                                        :disabled="true"
                                        type="text"
                                        v-model="form.room_state_id"
                                        prepend-icon="book"
                                        required
                                        :rules="requireText"
                                    ></v-text-field>
                                </v-flex> -->
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Số chứng từ"
                                        type="text"
                                        :disabled="loading.submit"
                                        v-model="form.receipt_id"
                                        prepend-icon="book"
                                        required
                                        :rules="requireText"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex v-if="form.deposit_type === 1" xs12 md3>
                                    <v-select
                                        label="Người dẫn phòng"
                                        :disabled="loading.submit"
                                        v-model="form.agent"
                                        :items="[...bvs, { name: 'Chuyển phòng'}]"
                                        item-text="name"
                                        return-object
                                        prepend-icon="person_pin"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Người tạo phiếu"
                                        :disabled="loading.submit"
                                        v-model="form.collector"
                                        :items="bvs"
                                        item-text="name"
                                        item-value="name"
                                        prepend-icon="domain"
                                        :rules="requireText"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Hình thức thu tiền"
                                        :disabled="loading.submit"
                                        v-model="form.wallet_account_id"
                                        :items="wallets"
                                        item-text="name"
                                        item-value="id"
                                        prepend-icon="account_balance_wallet"
                                        :rules="requireText"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-text-field
                                        label="Họ tên người nộp tiền"
                                        :disabled="loading.submit"
                                        v-model="form.name"
                                        prepend-icon="account_box"
                                        required
                                        :rules="requireText"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-text-field
                                        label="Số điện thoại"
                                        :disabled="loading.submit"
                                        v-model="form.phone"
                                        prepend-icon="contact_phone"
                                        required
                                        :rules="requirePhone"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex v-if="form.deposit_type === 1" xs12 md6>
                                    <v-text-field
                                        label="Giá phòng:"
                                        disabled
                                        v-model="form.room_price_old"
                                        required
                                        prepend-icon="attach_money"
                                        :rules="requireNumber"
                                    >
                                        <template slot="append">
                                            VND
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <!-- <v-flex v-if="form.deposit_type === 1" xs12 md6>
                                    <v-text-field
                                        label="Giá phòng mới:"
                                        disabled
                                        v-model="form.room_price"
                                        :rules="requireNumber"
                                        required
                                        prepend-icon="attach_money"
                                    >
                                        <template slot="append">
                                            VND
                                        </template>
                                    </v-text-field>
                                </v-flex> -->
                                <!-- <v-flex v-if="form.deposit_type === 1" xs12 md6>
                                    <v-text-field
                                        label="Tổng số tiền phải cọc:"
                                        :disabled="loading.submit"
                                        v-model="form.deposit_price"
                                        required
                                        prepend-icon="attach_money"
                                        :rules="requireNumber"
                                    >
                                        <template slot="append">
                                            VND
                                        </template>
                                    </v-text-field>
                                </v-flex> -->
                                <v-flex xs12 md6>
                                    <v-text-field
                                        label="Số tiền hiện cọc:"
                                        :disabled="loading.submit"
                                        v-model="form.deposit_amount"
                                        required
                                        prepend-icon="attach_money"
                                        :rules="requireNumber"
                                    >
                                        <template slot="append">
                                            VND
                                        </template>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <v-text-field
                                        label="Ghi chú"
                                        :disabled="loading.submit"
                                        v-model="form.note"
                                        prepend-icon="event_note"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-container>
                    <v-card-actions v-if="form.room_state_id">
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="loading.submit"
                            @click="cancelInput"
                        >
                            Trở về
                        </v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >
                            Tạo Phiếu Thu Tiền Cọc
                        </v-btn>
                    </v-card-actions>
                    <!-- <v-btn @click="clear" color="primary">{{$t("message.clear")}}</v-btn> -->
                </v-form>
            </app-card>
        </v-dialog>

        <edit-receipt-component
            title="CHỈNH SỬA PHIẾU CỌC"
            receipt_type="deposit"
            hide_button
            :edit_field="edit_field"
            :selected_receipt="chosen_receipt"
            :trigger="trigger_edit_component"
            @updateCurrentReceipt="updateCurrentReceipt"
        >
        </edit-receipt-component>


        <chuyen-coc-component
            hide_button
            :selected_receipt="chosen_receipt"
            :list_building="list_building"
            :trigger="trigger_transfer_deposit_component"
            @changeRoomId="changeRoomId"
        >
        </chuyen-coc-component>
	</div>
</template>

<script>
import api from "../../api";
import XLSX from 'xlsx'
import moment from 'moment'
import { buildParamQuery, formatTimeServer, translateWalletName } from '../../helpers/helpers.js'
import utf8 from 'utf8'
import ChuyenCocComponent from '../../components/Phieu/ChuyenCocComponent'
import EditReceiptComponent from '../../components/Phieu/EditReceiptComponent'
import { list_building } from '../../constants/db-config'
import ExportCsvButton from '../../components/ExportExcel/ExportCsvButton'

export default {
    name: 'PhieuThuTienCoc',
    components: {
        ChuyenCocComponent,
        EditReceiptComponent,
        ExportCsvButton
    },
    data() {
        return {
            dialog: false,
            total_amount_deposited: 0,
            total_amount_must_deposit: 0,
            form: {
                receipt_id: '21',
                date_deposit: new Date().toISOString().substr(0, 10),
                name:'',
                phone: '',
                building: '',
                room_id: '',
                room_price_old: '2,700,000',
                room_price: '2,700,000',
                deposit_amount: '1,000,000',
                deposit_price: '1,000,000',
                date_schedule_in: new Date().toISOString().substr(0, 10),
                note: '',
                agent: '',
                room_state_id: '',
                deposit_type: 1
            },
            menu_date_deposit: false,
            menu_date_schedule_in: false,
            menu_month_picker: false,
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            loader: false,
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                { text: "Loại", align: "center", sortable: true, value: "deposit_type" },
                { text: "#Chứng từ", align: "center", sortable: true, value: "receipt_id" },
                { text: "Ngày cọc", align: "left", sortable: true, value: "date_deposit" },
                { text: "Hẹn nhận phòng", align: "left", sortable: true, value: "date_schedule_in" },
                { text: "Phòng", align: "left", sortable: true, value: "room_id" },
                { text: "Trạng thái phiếu", align: "center", sortable: true, value: "receipt_status" },
                { text: "Trạng thái phòng", align: "left", sortable: true, value: "is_check_in" },
                {text: "Hình thức", align: "center", sortable: true, value: "wallet_account_id"},
                { text: "Người dẫn", align: "left", sortable: true, value: "agent_name" },
                { text: "Họ tên", align: "left", sortable: false, value: "name" },
                { text: "SDT", align: "left", sortable: false, value: "phone" },
                { text: "Giá phòng", align: "left", sortable: false, value: "room_price" },
                { text: "Số tiền đã cọc", align: "left", sortable: true, value: "deposit_amount" },
                { text: "Diễn giải", align: "left", sortable: false },
            ],
            items: [],
            loading: {
                submit: false
            },
            form_loader: false,
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            input_excel: null,
            chosen_building: 'BN',
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Mã số phiếu', value: 'receiptId' },
                { text: 'Mã quản lý', value: 'roomStateId' },
                { text: 'Tên khách hàng', value: 'name' },
            ],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            search:'',
            search_type: 'roomId',
            requireNumber: [
                v => !!v || "Vui lòng nhập thông tin này",
                v => /^[0-9]*$/.test(v.replace(/,/g, '')) || 'Vui lòng nhập số'
            ],
            requireText: [
                v => !!v || "Vui lòng nhập thông tin này",
            ],
            requirePhone: [
                v => !!v || 'Vui lòng nhập thông tin này',
                v => (v && v.length <= 10) || 'SDT phải ngắn hơn 10 ký tự',
            ],
            edit_field: {
                receipt_id: {
                    type: "text",
                    flex_attr: "xs12 md4",
                    label: "Số chứng từ",
                    disabled: false,
                    prepend_icon: "book",
                    rule: "require"
                },
                name: {
                    type: "text",
                    flex_attr: "xs12 md4",
                    label: "Họ tên người nộp tiền",
                    disabled: false,
                    prepend_icon: "account_box",
                    rule: "require"
                },
                phone: {
                    type: "text",
                    flex_attr: "xs12 md4",
                    label: "Số điện thoại",
                    disabled: false,
                    prepend_icon: "contact_phone",
                    rule: "requirePhone"
                },
                deposit_amount: {
                    type: "money",
                    flex_attr: "xs12 md4",
                    label: "Số tiền hiện cọc",
                    disabled: false,
                    prepend_icon: "attach_money",
                    rule: "required"
                },
                date_deposit: {
                    type: "date",
                    flex_attr: "xs12 md4",
                    label: "Ngày đặt cọc",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "required"
                },
                date_schedule_in: {
                    type: "date",
                    flex_attr: "xs12 md4",
                    label: "Ngày hẹn nhận phòng",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "required"
                },
                room_price: {
                    type: "money",
                    flex_attr: "xs12 md4",
                    label: "Giá phòng",
                    disabled: false,
                    prepend_icon: "attach_money",
                    rule: "required"
                },
                agent: {
                    type: "agent",
                    flex_attr: "xs12 md4",
                    disabled: false,
                    rule: "required"
                },
                wallet_account_id: {
                    type: "wallet",
                    flex_attr: "xs12 md4",
                    label: "Hình thức thu tiền",
                    disabled: false,
                    rule: "require"
                },
                edit_note: {
                    type: "text",
                    flex_attr: "xs12 md12",
                    label: "Giải thích chỉnh sửa",
                    disabled: false,
                    prepend_icon: "event_note",
                    rule: "require"
                },
            },
            chosen_month: new Date().toISOString().substr(0, 7),
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
            },
            list_payment_type: [
                { text: "Tất cả", value: "" },
                { text: "Tiền mặt", value: "cash" },
                { text: "Chuyển khoản", value: "bank" }
            ],
            chosen_payment_type: "",
            trigger_edit_component: false,
            trigger_transfer_deposit_component: false,
            chosen_receipt: {},
            list_deposit_type: [
                { text: "All", value: "" },
                { text: "L1", value: 1 }
            ],
            chosen_deposit_type: "",
        };
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        },
        role(){
            return this.$store.state.auth.role
        },
        bvs(){
            return this.$store.state.app.bvs
        },
        wallets(){
            return this.$store.state.app.wallets
        },
        filtered_items(){
            const payment_type = this.chosen_payment_type
            const deposit_type = this.chosen_deposit_type
            return this.items.filter(item => {
                let check_payment_type = false
                let check_deposit_type = false
                switch(payment_type) {
                    case "cash":
                        check_payment_type = item.wallet_account_id == 1;
                        break;
                    case "bank":
                        check_payment_type = item.wallet_account_id != 1
                        break;
                    default:
                        check_payment_type = true
                }
                switch(deposit_type){
                    case 1:
                        check_deposit_type = item.deposit_type == 1;
                        break;
                    default:
                        check_deposit_type = true;
                }
                return check_payment_type && check_deposit_type
                // if (!this.chosen_payment_type && !this.chosen_deposit_type)
                //     return true
                // else if (this.chosen_payment_type == "cash" && item.wallet_account_id == 1 && (!this.chosen_deposit_type || item.deposit_type == this.chosen_deposit_type))
                //     return true
                // else if (this.chosen_payment_type == "bank" && item.wallet_account_id != 1 && (!this.chosen_deposit_type || item.deposit_type == this.chosen_deposit_type))
                //     return true
                // return false
            })
        }
    },
    watch: {
        'form.room_id'(nv){
            if (nv){
                this.getRoomState(nv)
                const chosen_room =  this.rooms.find(room => room.room_id == nv)
                this.form.room_price = chosen_room && chosen_room.room_price ? chosen_room.room_price : 2700000
                this.form.room_price_old = chosen_room && chosen_room.room_price ? chosen_room.room_price : 2700000
                this.form.deposit_price = chosen_room && chosen_room.deposit_price ? chosen_room.room_price : 2700000
                this.form.deposit_price_old = chosen_room && chosen_room.deposit_price ? chosen_room.room_price : 2700000
                this.form.deposit_amount = chosen_room && chosen_room.deposit_price ? chosen_room.room_price : 2700000
            }
        },
        'form.room_price': function (nv, ov){
            this.form.room_price = nv ? nv.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
        },
        'form.deposit_amount': function (nv, ov){
            this.form.deposit_amount = nv ? nv.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
        },
        'form.room_price_old': function (nv, ov){
            this.form.room_price_old = nv ? nv.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
        },
        'form.deposit_price': function (nv, ov){
            this.form.deposit_price = nv ? nv.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
        },
        dialog: function (nv, ov){
            if (!nv) this.clearInput()
        },
		// chosen_month: {
		// 	handler: function (nv){
		// 		this.getData(nv)
		// 	},
		// 	immediate: true
        // },
        date_start: function(nv){
            if (nv && this.date_end) this.getData()
        },
        date_end: function(nv){
            if (nv && this.date_start) this.getData()
        }
    },
    created(){
        if (this.role === 'ADMIN'){
            this.headers.push({ text: "Hủy cọc", align: "left", sortable: false })
        }
        this.getData()
    },
    methods: {
        clearInput(){
            this.form = {
                receipt_id: '21',
                date_deposit: new Date().toISOString().substr(0, 10),
                name:'',
                phone: '',
                building: '',
                room_id: '',
                room_price_old: '2,700,000',
                room_price: '2,700,000',
                deposit_amount: '1,000,000',
                deposit_price: '1,000,000',
                deposit_price_old: '1,000,000',
                date_schedule_in: new Date().toISOString().substr(0, 10),
                note: '',
                agent: '',
                room_state_id: '',
                deposit_type: 1
            }
            this.$refs.form.resetValidation()
            this.total_amount_deposited = 0
            this.total_amount_must_deposit = 0
        },
        getRoomState: async function (roomId){
            this.form_loader = true
            this.alert.show = false
            this.total_amount_must_deposit = 0
            this.total_amount_deposited = 0
            const data = await api.getRoomState( "roomId=" + roomId )
            if ( data.status == 200 ){
                const roomState = data.data ? data.data.roomState : null
                const old_room_state_id = roomState ? data.data.roomState.room_state_id : null
                const date_schedule_out = roomState ? data.data.roomState.date_schedule_out : null
                const is_valid_room_state = roomState ? data.data.roomState.is_valid : null
                // if ( is_valid_room_state && old_room_state_id && !date_schedule_out ) {
                //     this.form.room_state_id = null
                //     this.alert.show = true
                //     this.alert.text = `Phòng ${ this.form.room_id } hiện đang hoạt động và chưa có ngày trả phòng, vui lòng chọn chính xác phòng cần đặt cọc`
                // } else {
                //     const new_room_state_id = old_room_state_id ? this.handleRoomState(old_room_state_id) : `${this.form.room_id}-1`
                //     this.form.room_state_id = new_room_state_id
                // }
                if ( is_valid_room_state && old_room_state_id && !roomState.date_schedule_out ) {
                    this.form.deposit_type = roomState.deposits.length + 1
                    this.form.room_state_id = old_room_state_id
                    const total_amount_deposited = roomState.deposits.reduce((acc, cur) => acc + cur.deposit_amount,0)
                    const data_old_deposit = await api.getDepositReceipts('receiptId=' + roomState.deposits[roomState.deposits.length - 1].receipt_id)
                    const old_deposit = data_old_deposit.data[0]
                    this.form.name = roomState.name
                    this.form.phone = roomState.phone
                    if (old_deposit){
                        this.form.room_price = old_deposit.room_price
                        this.form.room_price_old = old_deposit.room_price
                        this.form.deposit_price = old_deposit.deposit_price
                        this.form.deposit_price_old = old_deposit.deposit_price
                        this.form.deposit_amount = old_deposit.deposit_price + old_deposit.room_price - total_amount_deposited
                        this.total_amount_must_deposit = old_deposit.deposit_price + old_deposit.room_price
                    } else {
                        const params = {
                            roomId: this.form.room_id,
                            building: this.form.building,
                            contractValid: true,
                        }
                        const query = buildParamQuery(params)
                        const constract_data = await api.getListContracts(query)
                        if (constract_data.status !== 200 || !constract_data.data.contracts[0]) {
                            this.alert.show = true
                            this.alert.text = data.message ? data.message : 'Lỗi khi tải thông tin trạng thái phòng'
                            return
                        }
                        const room_contract = constract_data.data.contracts[0]
                        this.form.room_price = room_contract.room_price
                        this.form.room_price_old = room_contract.room_price
                        this.form.deposit_price = room_contract.deposit_price
                        this.form.deposit_price_old = room_contract.deposit_price
                        this.form.deposit_amount = room_contract.deposit_price + room_contract.room_price - total_amount_deposited
                        this.total_amount_must_deposit = room_contract.deposit_price + room_contract.room_price
                    }
                        this.total_amount_deposited = total_amount_deposited
                } else {
                    const new_room_state_id = old_room_state_id ? this.handleRoomState(old_room_state_id) : `${this.form.room_id}-1`
                    this.form.deposit_type = 1
                    this.form.name = ''
                    this.form.phone = ''
                    this.form.room_state_id = new_room_state_id
                }
                this.$refs.form.resetValidation()
            } else {
                this.alert.show = true
                this.alert.text = data.message ? data.message : 'Lỗi khi tải thông tin trạng thái phòng'
            }
            this.form_loader = false
        },
        getReceiptNewestNumber: async function (){
            this.form.room_state_id = null
            this.form.receipt_id = this.form.building + '-1'
            // this.form_loader = true
            const params = {
                receiptType: 'DEPOSIT',
                building: this.form.building
            }
            const query = buildParamQuery(params)
            const data = await api.getReceiptNumberNewest(query)
            if (data.status == 200 && data.data){
                const deposit_array = data.data
                if (deposit_array && deposit_array.length){
                    this.form.receipt_id = this.form.building + '-' + (Number(deposit_array[0].maxNumber) + 1)
                }
            }
            // this.form_loader = false

        },
        handleRoomState: function (room_state){
            let arr = room_state.split('-')
            arr[1] = Number(arr[1])+1
            return arr.join('-')
        },
        submit: async function () {
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            this.loading.submit = true
            let postData = Object.assign({}, this.form)
            postData.room_price_old = Number(this.form.room_price_old.replace(/,/g, ''))
            postData.room_price = Number(this.form.room_price.replace(/,/g, ''))
            postData.deposit_price = postData.room_price
            postData.deposit_price_old = this.form.deposit_price_old
            postData.deposit_amount = Number(this.form.deposit_amount.replace(/,/g, ''))
            postData.date_schedule_in = new Date(postData.date_schedule_in)
            postData.date_deposit = new Date(postData.date_deposit)

            postData.agent_id = this.form.agent.user_id
            postData.agent_name = this.form.agent.name || this.form.agent.username
            let data = await api.createDepositReceipt(postData)
            if (data.status === 200){
                this.dialog = false
                this.getData()
                this.clearInput()
                swal.fire('Thành công', 'Tạo thành công phiếu thu tiền cọc', 'success')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
            this.loading.submit = false
        },
        getData: async function (month){
            this.$store.commit('loading', true)
            this.items = []
            const params = {
                // building: this.chosen_building,
                // [this.search_type]: this.search,
                dateStart: this.date_start,
                dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            let data = await api.getDepositReceipts(query)
            this.$store.commit('loading', false)
            if ( data.status === 200){
                this.items = data.data.map( receipt => this.handleData(receipt))
                this.loader = false
            }
        },
        handleData: function (data){
            data.receipt_status = data.is_valid
                ? data.is_collected
                    ? 2
                    : 1
                : 0;
            return data
        },
        onFileSelected: function (e){
            let files = e.target.files, f = files[0];
            let reader = new FileReader();
            let that = this
            reader.onload = function(e) {
                that.loader = true
                let data = new Uint8Array(e.target.result);
                let arr = new Array();
                for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                let bstr = arr.join("");

                /* Call XLSX */
                let workbook = XLSX.read(bstr, {
                    type: "binary"
                });
                let first_sheet_name = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[first_sheet_name];
                that.input_excel = XLSX.utils.sheet_to_json(worksheet, {
                    raw: true
                });
                that.createDepositFromExcel()
            };
            reader.readAsArrayBuffer(f);
        },
        createDepositFromExcel: async function (){
            this.loading.submit = true
            let promises = this.input_excel.filter(data => data.name1)
                .map((data) => {
                    const roomData =  this.rooms.find(room => room.room_id === data.room_id)
                    if (!roomData) {
                        return null
                    }
                    let postData = {
                        receipt_id: this.createDepositId(data.building),
                        date_deposit: new Date('2019-07-01'),
                        // name: utf8.decode(data.name1),
                        name: data.name1,
                        phone: data.phone1 ? data.phone1.toString() : '1',
                        building: data.building,
                        room_id: data.room_id,
                        room_price: roomData.room_price,
                        room_price_old: roomData.room_price,
                        deposit_price: roomData.deposit_price,
                        deposit_price_old: roomData.deposit_price,
                        deposit_amount: roomData.deposit_price + roomData.room_price,
                        deposit_type: 1,
                        // date_schedule_in: data.date_in ? new Date(this.handleCustomDate(data.date_in)) : new Date('2019-05-01'),
                        date_schedule_in: new Date('2019-07-01'),
                        is_collected: true,
                        room_state_id: data.room_id + '-1'
                    }
                return api.createDepositReceipt(postData)
                })
            let data_array = await Promise.all(promises)
            let count_success = 0
            data_array.forEach(data => {
                if ( data.status === 200 ){
                    count_success++
                }
            });
            this.getData()
            swal.fire('Thành công', `Tạo thành công: ${count_success} phiếu`, 'success')
            this.loading.submit = false
        },
        handleCustomDate(date){
            date = date.toString()
            let year = date.slice(0, 4)
            let month = date.slice(4,6)
            let d = date.slice(6,8)
            return `${year}-${month}-${d}`
        },
        cancelDeposit(deposit) {
            let that = this
            swal.fire({
            title: 'Hủy Phiếu Cọc',
            text: `Bạn có chắc muốn hủy phiếu cọc:\n\nMã chứng từ: ${deposit.receipt_id}\nSố phòng ${deposit.room_id} ? Thao tác này sẽ đưa phòng về lại trạng thái chưa đặt cọc.`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Hủy phiếu cọc này',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true)
                    let data = await api.cancelDeposit({receipt_id: deposit.receipt_id, room_state_id: deposit.room_state_id})
                    that.$store.commit("loading", false)
                    if (data.status == 200){
                        swal.fire('Thành công', `Đã hủy thành công phiếu cọc số ${deposit.receipt_id}`, 'success')
                        deposit.is_valid = false
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        },
        cancelInput(){
            this.dialog = false
            this.clearInput()
        },
        changeRoomId(receipt_id, result_data){
            const selected_receipt = this.items.find(receipt => receipt.receipt_id === receipt_id);
            selected_receipt.room_id = result_data.room_id;
            selected_receipt.building = result_data.building;
            selected_receipt.room_state_id = result_data.room_state_id;
            // this.$set(selected_receipt, 'room_id', room_id)
        },
        updateCurrentReceipt(_id, updated_field){
            const selected_receipt = this.items.find(receipt => receipt._id === _id);
            for (const key in updated_field) {
                if (updated_field.hasOwnProperty(key)) {
                    const element = updated_field[key];
                    selected_receipt[key] = element;
                }
            }
        },
		exportCSV: function(){
			const rows = this.filtered_items.map(item => {
				return {
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Số chứng từ": item.receipt_id,
					"Cọc lần": item.deposit_type,
					"Ngày cọc": formatTimeServer(item.date_deposit),
					"Ngày hẹn nhận phòng": formatTimeServer(item.date_schedule_in),
					"Số tiền": item.deposit_amount,
					"Trạng thái phiếu": item.is_valid ? item.is_collected ? 'Chủ Trọ đã thu' : 'Chủ Trọ chưa thu' : "Đã hủy cọc",
					"Trạng thái phòng": item.is_check_in ? 'Chưa nhận phòng' : 'Đã nhận phòng',
					"Hình thức": item.wallet_account_id ? translateWalletName(item.wallet_account_id) : '',
					"Người dẫn": item.agent_name,
					"Họ và tên": item.name,
					"Số điện thoại": item.phone,
					"Giá phòng": item.room_price,
					"Ghi chú": item.note,
				}
			})
			this.export_csv.rows = rows;
			this.export_csv.title = this.chosen_month + "-phieu-coc";
			this.export_csv.trigger = !this.export_csv.trigger;
        },
        triggerDialog: function (receipt, type){
            this.chosen_receipt = receipt;
            if (type === 'edit') this.trigger_edit_component = !this.trigger_edit_component
            if (type === 'transfer') this.trigger_transfer_deposit_component = !this.trigger_transfer_deposit_component
        }
    }
};
</script>
<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>
